import axios from 'axios'
import {
  Toast,
  Dialog
} from 'vant'
import store from '../store'

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.BASE_API,
  baseURL: 'https://sc-api.zhihuishitang.net', // api的base_url【正式】
  // baseURL: 'http://newapi.zhihuishitang.net', // api的base_url【正式】
  timeout: 5000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.state.user.accessToken) {
    config.headers['accessToken'] = store.state.user.accessToken // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非10000是抛错 可结合业务进行修改
     */
    const res = response.data
    if (res.code !== '10000') {
      // 20000:accessToken 过期了;refreshToken重新置换accessToken
      if (res.code === '11003' || res.code === '11007' || res.code === '11002') {
        Dialog.alert({
          title: res.code,
          message: '帐户信息过期，请重新登录'
        }).then(() => {
          store.dispatch('USER_SIGNOUT').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      } else {
        Toast({
          message: res.msg,
          duration: 5 * 1000
        })
        return Promise.reject(res)
      }
    } else {
      return Promise.resolve(res)
    }
  },
  error => {
    Toast({
      message: '网络开小车儿了哈,请检查网络，稍后再试一下哈',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js